const Loader = () => (
    <span className="loading loading-spinner loading-md justify-self-center self-center"></span>
);

export default Loader;